export default "__VITE_ASSET__8dd0a730__"